import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subject, take, takeUntil } from 'rxjs';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { LineItemView } from 'ish-core/models/line-item/line-item.model';
import { GenerateLazyComponent } from 'ish-core/utils/module-loader/generate-lazy-component.decorator';

import { WishlistsFacade } from '../../facades/wishlists.facade';
import { Wishlist } from '../../models/wishlist/wishlist.model';
import { WishlistPreferencesDialogComponent } from '../wishlist-preferences-dialog/wishlist-preferences-dialog.component';

@Component({
  selector: 'custom-basket-create-wishlist',
  templateUrl: './basket-create-wishlist.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
@GenerateLazyComponent()
export class BasketCreateWishlistComponent implements OnInit, OnDestroy {
  @Input() products: LineItemView[];
  @Input() cssClass: string;

  loading$: Observable<boolean>;

  private destroy$ = new Subject<void>();

  constructor(private wishListFaced: WishlistsFacade, private accountFacade: AccountFacade, private router: Router) {}

  ngOnInit(): void {
    this.loading$ = this.wishListFaced.wishlistLoading$;
  }

  /**
   * if the user is not logged in display login dialog, else open select order template dialog
   */
  openModal(modal: WishlistPreferencesDialogComponent) {
    this.accountFacade.isLoggedIn$.pipe(take(1), takeUntil(this.destroy$)).subscribe(isLoggedIn => {
      if (isLoggedIn) {
        modal.show();
      } else {
        // stay on the same page after login
        const queryParams = { returnUrl: this.router.routerState.snapshot.url, messageKey: 'ordertemplates' };
        this.router.navigate(['/login'], { queryParams });
      }
    });
  }

  createWishList(whishList: Wishlist) {
    this.wishListFaced.addProductsToNewWishList(whishList);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
